import { render, staticRenderFns } from "./edit-ordersignfor.vue?vue&type=template&id=a7bce706&"
import script from "./edit-ordersignfor.vue?vue&type=script&lang=ts&"
export * from "./edit-ordersignfor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-ordersignfor.vue"
export default component.exports